import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home/Home';
import peopleRoutes from '@/routes/people/router';
import modalsRoutes from '@/routes/modals/router';
import calendarRoutes from '@/routes/calendar/router';
import projectsRoutes from '@/routes/projects/router';
import notebooksRoutes from '@/routes/notebooks/router';
import everythingRoutes from '@/routes/everything/router';

Vue.use(Router);

const baseRoutes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
];

const routes = [
  ...baseRoutes,
  ...peopleRoutes,
  ...calendarRoutes,
  ...projectsRoutes,
  ...notebooksRoutes,
  ...modalsRoutes,
  ...everythingRoutes,
];

export default new Router({
  base: process.env.VUE_APP_PUBLIC_PATH,
  mode: 'history',
  routes,
});
